import {
  Box,
  Typography,
  Grid,
  Button,
  Dialog,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import React, { useState, useRef } from "react";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";


const EventDetails = ({ event, onBack }) => {
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const touchStartX = useRef(null);

  if (!event) return null;

  const openLightbox = (index) => {
    setActiveIndex(index);
    setOpen(true);
  };

  const closeLightbox = () => setOpen(false);

  const next = () =>
    setActiveIndex((prev) =>
      prev === event.gallery.length - 1 ? 0 : prev + 1
    );

  const prev = () =>
    setActiveIndex((prev) =>
      prev === 0 ? event.gallery.length - 1 : prev - 1
    );

  /* ---------- Swipe handlers ---------- */
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    if (!touchStartX.current) return;

    const deltaX =
      e.changedTouches[0].clientX - touchStartX.current;

    if (deltaX > 50) prev();
    if (deltaX < -50) next();

    touchStartX.current = null;
  };

  const hasMedia = Array.isArray(event.gallery) && event.gallery.length > 0;
  const currentMedia = hasMedia ? event.gallery[activeIndex] : null;
  const isVideo = !!currentMedia && currentMedia.endsWith(".mp4");

  return (
    <Box>
      {/* ---------- BACK BUTTON ---------- */}
      <Button onClick={onBack} sx={{ mb: 4 }}>
        ← Back to Events
      </Button>

      {/* ---------- TITLE ---------- */}
      <Typography
        variant="h4"
        sx={{ fontWeight: 700, mb: 4 }}
      >
        {event.title}
      </Typography>

      {/* ---------- GALLERY GRID ---------- */}
      {!hasMedia && (
        <Typography sx={{ color: "text.secondary" }}>
          Photos coming soon.
        </Typography>
      )}
      <Grid container spacing={3}>
        {event.gallery.map((src, idx) => (
          <Grid item xs={12} sm={6} md={4} key={idx}>
          <Box
  onClick={() => openLightbox(idx)}
  sx={{
    cursor: "pointer",
    borderRadius: 3,
    overflow: "hidden",
    position: "relative",
  }}
>
  {src.endsWith(".mp4") ? (
    <>
      <video
        src={src}
        muted
        playsInline
        style={{
          width: "100%",
          height: 240,
          objectFit: "cover",
        }}
      />

      {/* PLAY ICON OVERLAY */}
      <PlayCircleOutlineIcon
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: 64,
          color: "rgba(255,255,255,0.85)",
          pointerEvents: "none",
        }}
      />
    </>
  ) : (
    <img
      src={src}
      alt=""
      style={{
        width: "100%",
        height: 240,
        objectFit: "cover",
      }}
    />
  )}
</Box>

          </Grid>
        ))}
      </Grid>

      {/* ---------- LIGHTBOX MODAL ---------- */}
      <Dialog
        open={open}
        onClose={closeLightbox}
        fullScreen
        PaperProps={{ sx: { bgcolor: "black" } }}
      >
        {/* Close */}
        <IconButton
          onClick={closeLightbox}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            color: "white",
            zIndex: 10,
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* Prev */}
        <IconButton
          onClick={prev}
          sx={{
            position: "absolute",
            top: "50%",
            left: 16,
            color: "white",
            zIndex: 10,
          }}
        >
          <ArrowBackIosNewIcon />
        </IconButton>

        {/* Next */}
        <IconButton
          onClick={next}
          sx={{
            position: "absolute",
            top: "50%",
            right: 16,
            color: "white",
            zIndex: 10,
          }}
        >
          <ArrowForwardIosIcon />
        </IconButton>

        {/* Media */}
        <Box
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {isVideo ? (
            <video
              src={currentMedia}
              controls
              playsInline
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
              }}
            />
          ) : (
            <img
              src={currentMedia}
              alt=""
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
              }}
            />
          )}
        </Box>
      </Dialog>
    </Box>
  );
};

export default EventDetails;
